import JsEncrypt from "jsencrypt";

/**
 * forEach array
 * @param {Array} arr array
 * @param {Function} fn callback
 */
export const forEach = (arr, fn) => {
  if (!arr.length || !fn) return;
  let i = -1;
  const len = arr.length;
  while (++i < len) {
    const item = arr[i];
    fn(item, i, arr);
  }
};

/**
 * get label from enumeration
 * @param {string} val value
 * @param {sreing} type type of val
 * @return {string} label
 */
export const getLabelFromEnum = (val, enums, type) => {
  for (let i = 0; i < enums.length; i++) {
    const item = enums[i];
    if (!type) {
      // only receive number
      val = typeof val === "string" ? Number(val) : val;
      if (item.value === val) {
        return item.label;
      }
    } else if (type === "string") {
      // check with String
      if (item.value === val) {
        return item.label;
      }
    }
  }
  return "";
};

/**
 * get guid
 */
export const uuid = (len, radix) => {
  const chars = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz".split(
    ""
  );
  const uuid = [];
  let i;
  radix = radix || chars.length;

  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | (Math.random() * radix)];
  } else {
    // rfc4122, version 4 form
    let r;

    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = "-";
    uuid[14] = "4";

    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | (Math.random() * 16);
        uuid[i] = chars[i === 19 ? (r & 0x3) | 0x8 : r];
      }
    }
  }

  return uuid.join("");
};

/**
 * rsa encryption
 * @param {string} password fields that need to be encrypted
 * @param {string} publicKey public key
 * @return encryption result
 */
export const rsa = (password, publicKey) => {
  const jse = new JsEncrypt();
  // set public key
  jse.setPublicKey(publicKey);
  // encryption
  return jse.encrypt(password);
};

/**
 * hump
 * @param {string} text text need to be named by hump
 * @return {string} result
 */
export const toHump = text => {
  text = text.toLowerCase();
  return text.replace(/\b(\w)|\s(\w)/g, function(m) {
    return m.toUpperCase();
  });
};

export const formatDate = (dataStr, format = "default") => {
  // let today = new Date().getTime();
  // let date =
  //   typeof dataStr === "string" ? new Date(dataStr).getTime() : dataStr;
  // let time_diff = Math.abs(date - today);

  let res = "";

  switch (format) {
    case "default":
      res = "";
      break;
    case "duration":
      res = formatDateDuration(dataStr);
      break;
  }

  return res;
};

export const formatDateDuration = dataStr => {
  let diff = "";

  const fullDate =
    typeof dataStr === "string" ? new Date(dataStr).getTime() : dataStr;
  const today = new Date().getTime();
  const timeDiff = Math.abs(fullDate - today);

  // count years
  const years = Math.floor(timeDiff / (365 * 24 * 3600 * 1000));
  // diff += years > 0 ? `${ years }年` : "";

  // count months
  const months = Math.floor(timeDiff / (30 * 24 * 3600 * 1000));

  // count days
  const days = Math.floor(timeDiff / (24 * 3600 * 1000));
  // if (days > 0) {
  //   diff += days + "天";
  // }

  // count hours
  const hours = Math.floor(timeDiff / (3600 * 1000));

  // count minutes
  const minutes = Math.floor(timeDiff / (60 * 1000));

  // count hours
  // let leaveHour = time_diff % (24 * 3600 * 1000);
  // hours = Math.floor(time_diff / (3600 * 1000));
  // if (hours > 0) {
  //   diff += hours + "小时";
  // } else {
  //   if (diff !== "") {
  //     diff += hours + "小时";
  //   }
  // }

  // count minutes
  // let leaveMinutes = leaveHour % (3600 * 1000);
  // minutes = Math.floor(leaveMinutes / (60 * 1000));
  // if (minutes > 0) {
  //   diff += minutes + "分";
  // } else {
  //   if (diff !== "") {
  //     diff += minutes + "分";
  //   }
  // }

  // count seconds
  // var leaveSeconds = leaveMinutes % (60 * 1000);
  // var seconds = Math.round(leaveSeconds / 1000);
  // if (seconds > 0) {
  //   diff += seconds + "秒";
  // } else {
  //   if (diff !== "") {
  //     diff += seconds + "秒";
  //   }
  // }

  // formate
  // if (format === "default") {
  //
  // }

  if (years > 0) {
    diff = `${years}年前`;
    // console.log(diff);
    return diff;
  }

  if (months > 0) {
    diff = `${months}个月前`;
    // console.log(diff);
    return diff;
  }

  if (days > 0) {
    diff = `${days}天前`;
    // console.log(diff);
    return diff;
  }

  if (hours > 0) {
    diff = `${hours}小时前`;
    // console.log(diff);
    return diff;
  }

  if (minutes > 0) {
    diff = `${minutes}分钟前`;
    // console.log(diff);
    return diff;
  }

  return "刚才";
};

export const toThousandsFormates = num => {
  // 判断传进来的数字是否为非空数字
  if (!isNaN(parseFloat(num))) {
    let reg = /\./g;
    let newNum = Number(Number(num).toFixed(2)).toLocaleString();
    // 判断转换后的数字是否带有小数
    if (reg.test(newNum)) {
      let numArr = newNum.split(".");
      // 判断小数点后数字长度为1，则自动补0
      numArr[1] = numArr[1].length === 1 ? numArr[1] + "0" : numArr[1];
      return numArr.join(".");
    } else {
      // 整数直接在后面补上0.00
      return newNum + ".00";
    }
  } else {
    return "";
  }
};

/**
 * 格式化form error错误对象
 * @param {Object} _this vue实例对象
 * @param {Object} target error实例对象
 * @param {Object} error 错误
 */
export const formatFormError = (_this, target, error) => {
  // 清空error
  Object.keys(target).forEach(k => (target[k] = ""));

  // 处理错误
  if (typeof error === "string") {
    // 普通信息
    this.$message.error(error);
  } else {
    // 错误对象
    Object.keys(error).forEach(k => {
      if (k in target) {
        target[k] = "";
        _this.$nextTick(() => {
          target[k] = error[k];
        });
      }
    });
  }
};

/**
 * 当前环境是否是开发环境
 */
export const isDev = () => {
  return process.env.NODE_ENV === "development";
};
